import { Component, Inject, Input, OnInit, Optional, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { TransactionType } from 'src/app/models/transaction';
import { formatTitleCase } from 'src/app/shared/utility/common';

@Component({
    selector: 'app-supplier-detailed-charges-transaction-history-modal',
    templateUrl: './supplier-detailed-charges-transaction-history-modal.component.html',
    styleUrls: ['./supplier-detailed-charges-transaction-history-modal.component.scss']
})
export class SupplierDetailedChargesTransactionHistoryModal implements OnInit {
    public form: FormGroup;
    public campaignId: string;
    dataSource = null;
    columns = [];
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    supplierTotalCharge;
    supplierName = '';

    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<SupplierDetailedChargesTransactionHistoryModal>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.dataSource = data.transactionDataSource;
        this.columns = data.columns;
        this.supplierTotalCharge = data.supplierTotalCharge;
        this.supplierName = data.supplierName;
    }

    ngOnInit(): void { }

    formatTransactionType(transactionType) {
        let result = transactionType;
        if (result == TransactionType.ADJUSTED_MF_CHARGES) {
            result = TransactionType.ADDITIONAL_MF_CHARGES;
        }

        return formatTitleCase(result);
    }
}
